<template>
  <div id="app" >
      <router-view/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import wx from 'weixin-js-sdk'
export default {
  name: 'App',
  computed: { ...mapGetters({ pageData: 'pageData'}) },
  data () {
    return {
        screenHeight: document.documentElement.clientHeight,
        originHeight: document.documentElement.clientHeight,
        signUrl:"",
        channelCodeFlag:false
    }
  },
  watch: {
      screenHeight (val) {
        this.$store.commit('newPageData', { key: 'isOriginHei', data: !(this.originHeight > val + 100)})
    }
  },
  methods: {
    getShare() {
        // console.log(location.href)
        // let url = "?url=" + location.href
        this.signUrl=location.href;
        let codeIndex=this.signUrl.indexOf("?");
        if(codeIndex!=undefined && codeIndex>=0){
          this.signUrl=this.signUrl.substring(0,codeIndex);
        }
        let url = "?url=" + this.signUrl
        this.$http.get(this.$api.getSignature+ url,{}).then(res=>{
            this.setShare(res.data)
        })
    },
    setShare(res) {
      let that = this
            wx.config({
                debug: false,
                appId: res.data.appId, // 和获取Ticke的必须一样------必填，公众号的唯一标识
                timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                signature: res.data.signature,// 必填，签名，见附录1
                //需要分享的列表项:发送给朋友，分享到朋友圈，分享到QQ，分享到QQ空间
                jsApiList: [
                    'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage'
                ]
            });
            wx.checkJsApi({ // 检测api是否可用
              jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
              success: function(res) {
              // 以键值对的形式返回，可用的api值true，不可用为false
              // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
              }
            })

            //分享的参数
            let shareMsage = {
              title: '艺术云链',
              desc: '数字艺术公共服务平台',
              link: that.signUrl,
              imgUrl: 'https://cdn-test.pixdaddy.com/test/h5Image/logo/logo.jpeg'
            }
            
        //监听分享动作
        wx.ready(function () {
            //分享给好友
            wx.updateAppMessageShareData({
                title: shareMsage.title, // 分享标题
                desc: shareMsage.desc,	//分享的描述
                link: shareMsage.link, // 分享链接，该链接域名必须与当前企业的可信域名一致
                imgUrl: shareMsage.imgUrl, // 分享图标
                success: function() {
                  //that.$toast('分享成功')
                },
            });
            //分享到朋友圈
            wx.updateTimelineShareData({
              title: shareMsage.title, // 分享标题
              desc: shareMsage.desc,	//分享的描述
              link: shareMsage.link, // 分享链接，该链接域名必须与当前企业的可信域名一致
              imgUrl: shareMsage.imgUrl, // 分享图标
              success: function() {
                //that.$toast('分享成功')
              },
            });
        });

    },
    getUrlKey(name) {
      // 截取地址栏参数
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    }
  },
  created() {
     // 记录设备信息
     
    if(!this.channelCodeFlag){
      let channelCode=this.getUrlKey("channelCode");
      console.log("vvc:"+channelCode)
      if(channelCode!=undefined && channelCode.length > 0){
          this.$http.post(this.$api.saveChannel, { channelCode: channelCode }).then((res) => {
            
          });
      }
    }
    console.log(this.$util.goPage)
    let s = sessionStorage.getItem('reloads')
    if(!s) {
      sessionStorage.setItem('reloads','1')
      location.reload()
    }
  },
  mounted() {
    this.getShare(); 

    // this.$util.goPage({name: 'signName'})
    let self = this;
    window.onresize = function() {
        return (function(){
            self.screenHeight = document.documentElement.clientHeight;
        })()
      }
  }
}
</script>

<style lang="less">
// @font-face{
//   font-family: 'PingFangSC-Regular';
//   src: url('/assets/pingFangRegular.ttf');
//   font-weight: normal;
//   font-style: normal;
// }

body,html {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
#app {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // color: #2c3e50;
  background: #F9FBFC;
}
.appPage {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

h1, h2,h3, h4,
ul,li,p {
  margin: 0;
  padding: 0;
  list-style-type: none;
  font-weight: normal;
}
li {
  display: inline-block;
}
.center {
  text-align: center;
}
.van-dialog {
  width: 88% !important;
}
.btm {
  font-size:11px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666;
  height: 1;
  text-align: center;
}
.van-toast {
  z-index: 9999 !important;
  top: 222px  !important;
  width: 75% !important;
  max-width: 75% !important;
}
// -webkit-line-clamp:30;
.ddd {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  white-space: nowrap;
}
.p8 {
  padding: 0 8px;
}
.p10 {
  padding: 0 10px;
}
.p12 {
  padding: 0 12px;
}
.ddd2 {
  display: block;
  overflow: hidden;
  -webkit-line-clamp:2;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.ddd5 {
  display: block;
  overflow: hidden;
  -webkit-line-clamp:5;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}
.van-sticky {
  margin-left: -10px;
}
  .tabs{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    &>div{
      width: 100%;
      height: 100%;
    }
    .van-sticky {
      .van-tabs__wrap {
        box-sizing: border-box;
        width: 100%;
      }
    }
    .van-sticky--fixed {
      width: 100%;
      padding: 0 16px;
      box-sizing: border-box;
      background: #F9FBFC;
    }
    .van-tabs__wrap {
      .van-tabs__nav {
        width: 100%;
        background: #F9FBFC;
        display: inline-block;
        .van-tab {
          display: inline-block;
          vertical-align: middle;
        }
      }
    }
  }
.van-tabs__wrap {
  .van-tabs__nav {
    .van-tab {
      height: 40px;
      line-height: 40px;
       color: #999999;
      font-weight: 400;
    }
     .van-tab--active{
      color: #222;
      font-weight: 700;
    }
    .van-tabs__line {
      width: 54px;
      background: linear-gradient(270deg, #E091A9 0%, #9A7FCF 100%);
      box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.04);
      border-radius: 4px;
      height: 3.5px;
      bottom: 16px;
    }
  }
}
  .fixedBtm {
    bottom: 0;
    left: 0;
    width: 100%;
    position: fixed;
    height: 50px;
    width: 100%;
    padding: 0 12px;
    box-sizing: border-box;
    background: #FFFFFF;
    .num {
      float: left;
      font-size:20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 50px;
    }
    .sub {
      float: right;
      width: 166px;
      height: 40px;
      margin-top: 4px;
      border-radius: 40px;
      background: linear-gradient(270deg, #E091A9 0%, #9A7FCF 100%);
      border: none;
    }
  }
.valueTab {
  display: inline-block;
  padding: 0 8px;
  box-sizing: border-box;
  color: #FFFFFF;
  //line-height: 17.5px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  background: rgba(238, 238, 238, 0.8) !important;
  color: #958CE7 !important;
  padding-left: 0  !important;
  border-radius: 4px;
  font-size:10px;
  .name{
    padding: 0 8px;
    border-radius: 4px;
    background: #958CE7 !important;
    color: #FFFFFF !important;
  }
  .namexx{
    padding: 0 8px;
    //border-radius: 4px;
    border-top-left-radius:4px;
    border-bottom-left-radius:4px;
    background: #958CE7 !important;
    color: #FFFFFF !important;
    font-family: PingFangSC-Regular, PingFang SC;
    display:inherit;
    //line-height: 100%;
    //line-height: 20px;
    
  }
}
.home .swiper-pagination-fraction, 
.home .swiper-pagination-custom, 
.home .swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 4px;
}
.home .swiper-pagination-bullet {
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 100%;
    // background: rgba(204, 204, 204, 0.8);
    border-radius: 4px;
    border: 1px solid #FFFFFF;
    opacity: 0.4;
}
.home .swiper-pagination-bullet-active{
  width: 30px;
  background: linear-gradient(270deg, #E091A9 0%, #9A7FCF 100%);
  border-radius: 4px;
  border: none;
  opacity: 0.8;
}

/* This used to work for parent element of button divs */
/* But it is not enough now, below dont hide play button parent div */

.-webkit-media-controls-panel{
  display: none;
}

.-webkit-media-controls-play-button{
  display: none;
}

.-webkit-media-controls-start-playback-button{
  display: none;
}

*::-webkit-media-controls-panel {
  display: none!important;
  -webkit-appearance: none;
}

/* Old shadow dom for play button */
*::--webkit-media-controls-play-button {
  display: none!important;
  -webkit-appearance: none;
}

/* New shadow dom for play button */
/* This one works */
*::-webkit-media-controls-start-playback-button {
  display: none!important;
  -webkit-appearance: none;
}

// 播放按钮
video::-webkit-media-controls-play-button {
  display: none !important;
}
// 当前播放时间
video::-webkit-media-controls-current-time-display {
  display: none !important;
}
// 剩余时间
video::-webkit-media-controls-time-remaining-display {
  display: none !important;
}
// 音量按钮
video::-webkit-media-controls-volume-control-container {
  display: none !important;
}
// 全屏
video::-webkit-media-controls-fullscreen-button {
  display: none !important;
}
// 时间轴
video::-webkit-media-controls-timeline {
  display: none !important;
}
// 更多选项
video::-internal-media-controls-overflow-button {
  display: none !important;
}
video::-webkit-media-controls {
    overflow: hidden !important;
}
video::-webkit-media-controls-enclosure {
    width: calc(100% + 32px);
    margin-left: auto;
}
video::-internal-media-controls-download-button {
    display:none;
}

video::-webkit-media-controls-enclosure {
    display: none !important;
    overflow:hidden;
}

video::-webkit-media-controls-panel {
    width: calc(100% + 30px); 
}
.tabbar_icon{
  width:24px;
  height:24px;
}

.cptabbar_icon{
  margin-top: 4px;
  width:19px;
  height:20px;
  margin-bottom: 2px;
}

</style>

<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue